import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import TagField from '@/components/Tags/TagField';

import * as OrderFormTitleIcons from '@/orderForm/OrderForm/OrderFormTitleIcons';

const TagsFieldTemplate = ({ formData, onChange, required, rawErrors }) => {
  const intl = useIntl();
  const currentTags = formData?.tags ? formData.tags : Array.isArray(formData) ? formData : [];

  return (
    <div className="w-full">
      <div className="mb-[10px] mt-[4px] flex flex-wrap items-center gap-2">
        <div className="flex items-center justify-center">
          <OrderFormTitleIcons.Tag className="w-6 h-6 text-[#393939] shrink-0 object-contain" />
        </div>
        <span style={{ fontFamily: 'Open Sans', fontWeight: 700, fontSize: '16px', color: '#212529', display: 'inline-block' }}>
          {intl.formatMessage({ id: 'tags', defaultMessage: 'tags' })}
          {required && '*'}
        </span>
      </div>

      <div style={{ paddingLeft: '1vw', paddingRight: '1vw' }}>
        <p 
          className="text-gray-600 font-normal m-0 mb-3 font-['Open_Sans']"
          style={{ fontSize: 'calc(7px + 0.3vw)' }}
        >
          {intl.formatMessage({ id: 'ENTER_BOOKMARKS_TO_FILTER_ORDER_MESSAGE' })}
        </p>

        <div className="mt-1">
          <TagField
            value={currentTags.map(item => ({ value: item, label: item }))}
            handleChange={value => {
              const newTags = value ? value.map(item => item.value) : [];
              onChange({ tags: newTags });
            }}
            inputId="form-tags"
          />
        </div>
      </div>
      {rawErrors && rawErrors.length > 0 && (
        <p className="order-form-field-error">
          {rawErrors[0]}
        </p>
      )}
    </div>
  );
};

TagsFieldTemplate.propTypes = {
  formData: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  rawErrors: PropTypes.array,
};

TagsFieldTemplate.defaultProps = {
  formData: [],
  required: false,
};

export default TagsFieldTemplate;
